import axiosClient from './axiosClient';

export const getSales = (params?: Record<string, any>) => {
    return axiosClient.get('/sales', { params });
};

export const createSale = (data: Record<string, any>) => {
    return axiosClient.post('/sales', data);
};

export const updateSale = (id: string, data: Record<string, any>) => {
    return axiosClient.put(`/sales/${id}`, data);
};

export const deleteSale = (id: string) => {
    return axiosClient.delete(`/sales/${id}`);
};

export const uploadSaleAvatar = (id: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosClient.post(`/sales/${id}/avatar`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
export const getDashboardStats = () => {
    return axiosClient.get('/sales/dashboard/stats');
};

export const getSaleSubmissions = (params?: Record<string, any>) => {
    return axiosClient.get('/sales/submissions', { params });
};

export const getSubmissionDetail = (submissionId: string) => {
    return axiosClient.get(`/sales/submissions/${submissionId}`);
};

export const submitGrade = (submissionId: string, data: { score: number, feedback: string }) => {
    return axiosClient.patch(`/sales/submissions/${submissionId}/grade`, data);
};

export const getSaleTimetable = () => {
    return axiosClient.get('/sales/dashboard/timetable');
};

export const generateAIGradingSuggestion = (submissionId: string) => {
    return axiosClient.post(`/sales/submissions/${submissionId}/ai-grading`);
};
